"use strict";

var debounce = require("lodash/debounce");
var keyboardAccessibility = require("./keyboardAccessibility");
var accountPopover = require("./accountPopover");
var detectTouchDevice = require("../global/detectTouchDevice");
var stickyFilters = require("../search/search").stickyFilters;
var initHeaderBanner = require("./headerBanner");

let mainMenu = document.querySelector(".js-main-menu");
let togglerMenuBtn = document.querySelector(".js-navbar-toggler");
let overlay = document.querySelector(".l-overlay");
let backLevel = document.querySelectorAll(".js-back-level");
let navItemLinks = document.querySelectorAll(".js-nav-link");
let header = document.querySelector(".l-header");
let magnifyingGlass = document.querySelector(".l-header__sticky-search-button");
let mainContent = document.querySelector("#maincontent");
let headerContainer = document.querySelector(".l-header__container");
let submenuLink = document.querySelectorAll(".l-navigation__menu-link--with-submenu");
let filterBar = document.querySelector(".js-sticky-filter");
let minicartPopover = document.querySelector(".minicart-popover");
let scrolled = false;
let headerBanner = document.querySelector(".l-header-banner");
const $svgElement = $(".video-control, .video-control-fullscreen");

const openHamburger = () => {
    if (togglerMenuBtn) {
        togglerMenuBtn.addEventListener("click", e => {
            e.preventDefault();

            if (minicartPopover && minicartPopover.classList.contains("show")) {
                $("body").trigger("minicart:close");
            }

            mainMenu.classList.add("in");
            togglerMenuBtn.setAttribute("aria-expanded", "true");

            if (togglerMenuBtn.getAttribute("aria-expanded") == "true" && headerBanner) {
                headerBanner.classList.add("d-none");
            }

            overlay.classList.remove("d-none");
            mainMenu.classList.remove("d-none");
            headerContainer.classList.add("d-none");
            if (filterBar && filterBar.classList.contains("fixed-top")) {
                filterBar.classList.add("d-none");
            }
            mainMenu.previousElementSibling.setAttribute("aria-hidden", "true");
            mainMenu.setAttribute("aria-hidden", "false");
            header.nextElementSibling.removeAttribute("aria-hidden");
            document.querySelector(".main-menu .js-nav-link").focus();
        });
    }
};

const openLevel = () => {
    Array.from(navItemLinks).forEach(item => {
        item.addEventListener("click", (e) => {
            if (window.mqRespond.status.lgDown && !item.classList.contains("is-expanded")) {
                e.preventDefault();
                e.stopPropagation();

                // if not has element inside the selection toggle visibility between same level attributes on selection
                if (!(item.classList.contains("dropdown-toggle") || item.classList.contains("js-country-selector"))) {
                    let parentList = item.closest("ul.l-navigation__dropdown-menu");
                    let siblings = parentList.querySelectorAll(".js-nav-link");

                    Array.from(siblings).forEach(child => {
                        child.classList.remove("is-expanded", "c-button");
                        child.setAttribute("aria-expanded", "false");
                        child.parentNode.classList.remove("has-open-item");
                    });
                }

                item.classList.add("is-expanded", "c-button");
                item.setAttribute("aria-expanded", "true");
                item.parentNode.classList.add("has-open-item");
            } else if (window.mqRespond.status.lgDown) {
                // add theme color to the clicked button
                item.classList.add("c-button--primary", "active");

                // add loading overlay
                $(".l-navigation-overlay").removeClass("d-none");

                // if browser fails navigation remove spinner not to block user, in 10seconds
                setTimeout(function(){
                    $(".l-navigation-overlay").addClass("d-none");
                    window.location.href = $(item).attr("href");
                }, 10000);
            }
        });
    });
};

const openDesktopLevel = () => {
    Array.from(navItemLinks).forEach(item => {
        item.addEventListener("click", () => {
            if (!window.mqRespond.status.lgDown) {
                window.location.href = $(item).attr("href");
            }
        });
    });
};

const closeMobileLevel = () => {
    Array.from(navItemLinks).forEach(item => {
        if (item.classList.contains("is-expanded")) {
            item.classList.remove("is-expanded", "c-button");
            item.setAttribute("aria-expanded", "false");
            headerContainer.classList.remove("d-none");
            if (filterBar && filterBar.classList.contains("d-none")) {
                filterBar.classList.remove("d-none");
            }
            item.parentNode.classList.remove("has-open-item");
            item.nextElementSibling.setAttribute("aria-hidden", "true");
        }
    });
};

const goBack = () => {
    Array.from(backLevel).forEach(button => {
        button.addEventListener("click", (e) => {
            e.stopPropagation();
            let openedItems = document.querySelectorAll(".is-expanded");

            if (button.parentNode.querySelector(".is-expanded")) {
                button.parentNode.querySelector(".is-expanded").classList.remove("is-expanded", "c-button");
            }

            if (openedItems[openedItems.length - 1] && openedItems[openedItems.length - 1].classList.contains("dropdown-toggle")) {
                openedItems[openedItems.length - 1].nextElementSibling.setAttribute("aria-hidden", "true");
                openedItems[openedItems.length - 1].setAttribute("aria-expanded", "false");
            } else if (openedItems[openedItems.length - 1]) {
                openedItems[openedItems.length - 1].setAttribute("aria-expanded", "false");
                openedItems[openedItems.length - 1].setAttribute("aria-hidden", "true");
                openedItems[openedItems.length - 1].classList.remove("is-expanded", "c-button");
            }

            button.parentNode.classList.remove("has-open-item");
        });
    });
};

const closeHamburger = () => {
    if (mainMenu.classList.contains("in")) {
        mainMenu.classList.remove("in");
        overlay.classList.add("d-none");
        togglerMenuBtn.setAttribute("aria-expanded", "false");
        headerContainer.classList.remove("d-none");
        if (filterBar && filterBar.classList.contains("d-none")) {
            filterBar.classList.remove("d-none");
        }
        togglerMenuBtn.focus();
        mainMenu.setAttribute("aria-hidden", "true");
        document.querySelector("body").classList.remove("no-scroll");

        if (headerBanner) {
            headerBanner.classList.remove("d-none");
        }

        closeMobileLevel();
    }
};

const closeHamburgerOnOverlay = () => {
    if (overlay) {
        overlay.addEventListener ("click", function (e) {
            e.preventDefault();

            if (minicartPopover && minicartPopover.classList.contains("show") && overlay.classList.contains("l-overlay__active-cart")) {
                $("body").trigger("minicart:close");
            }

            mainMenu.classList.remove("in");
            this.classList.add("d-none");
            togglerMenuBtn.setAttribute("aria-expanded", "false");
            headerContainer.classList.remove("d-none");
            if (filterBar && filterBar.classList.contains("d-none")) {
                filterBar.classList.remove("d-none");
            }
            togglerMenuBtn.focus();
            mainMenu.setAttribute("aria-hidden", "true");
            document.querySelector("body").classList.remove("no-scroll");

            if (headerBanner) {
                headerBanner.classList.remove("d-none");
            }

            closeMobileLevel();
        });
    }
};

const openMenuOnKeydown = () => {
    if (!window.mqRespond.status.lgDown) {
        const firstLevelNavigation = [].slice.call(document.querySelectorAll(".js-first-level"));
        const firstLevelLink = [].slice.call(document.querySelectorAll(".first-level-link"));
        const $firstLevelNavigationItem = $(".js-first-level");

        firstLevelNavigation.forEach(menuItem => {
            menuItem.addEventListener("focusin", () => {
                if (!menuItem.classList.contains("menu-focused")) {
                    if ($firstLevelNavigationItem.hasClass("menu-focused")) {
                        $firstLevelNavigationItem.removeClass("menu-focused");
                    }
                }
            });
        });

        firstLevelLink.forEach(link => {
            link.addEventListener("focusin", () => {
                if (link.getAttribute("role") == "presentation") {
                    if ($firstLevelNavigationItem.hasClass("menu-focused")) {
                        $firstLevelNavigationItem.removeClass("menu-focused").attr("aria-expanded", "false");
                        $firstLevelNavigationItem.find(".l-navigation__dropdown").attr("aria-hidden", "true");
                        $firstLevelNavigationItem.find(".main-nav-link").attr("aria-expanded", "false");
                    }
                }
            });
        });

        keyboardAccessibility(".main-menu .nav-link",
            {
                40: function (menuItem) { // down
                    menuItem.addClass("menu-focused").attr("aria-expanded", "true");
                    menuItem.find(".l-navigation__dropdown").attr("aria-hidden", "false");
                    menuItem.find(".main-nav-link").attr("aria-expanded", "true");
                },
                38: function (menuItem) { // up
                    menuItem.removeClass("menu-focused").attr("aria-expanded", "false");
                    menuItem.find(".l-navigation__dropdown").attr("aria-hidden", "true");
                    menuItem.find(".main-nav-link").attr("aria-expanded", "false");
                }
            },
            function () {
                return $(this).parent();
            }
        );
    }

    submenuLink.forEach(item => {
        if (!window.mqRespond.status.lgDown) {
            item.setAttribute("aria-expanded", "true");
        } else {
            item.setAttribute("aria-expanded", "false");
        }
    });
};

const initNavigationMenu = () => {
    const firstLevelNavigation = [].slice.call(document.querySelectorAll(".js-first-level"));

    openHamburger();
    closeHamburger();
    closeHamburgerOnOverlay();
    openLevel();
    goBack();
    openDesktopLevel();
    openMenuOnKeydown();

    var navigationCloseButton = document.querySelector(".l-navigation__close-button");
    if (navigationCloseButton) {
        navigationCloseButton.addEventListener ("click", e => {
            e.preventDefault();
            closeHamburger();
        });
    }

    if (window.mqRespond.status.lgDown && !detectTouchDevice.isTouchDevice()) {
        firstLevelNavigation.forEach(menuItem => {
            menuItem.querySelector(".js-nav-link").setAttribute("aria-expanded", "false");
            menuItem.querySelector(".l-navigation__dropdown").setAttribute("aria-hidden", "true");
        });
        overlay.classList.add("d-none");
        header.classList.remove("is-focused");
    } else {
        $(".l-navigation__close-button").trigger("click");
        closeMobileLevel();

        firstLevelNavigation.forEach(menuItem => {
            menuItem.addEventListener("mouseenter", () => {
                menuItem.querySelector(".js-nav-link").setAttribute("aria-expanded", "true");
                menuItem.querySelector(".l-navigation__dropdown").setAttribute("aria-hidden", "false");
                mainMenu.classList.add("open-submenu");
                $(".suggestions-wrapper").addClass("not-visible");
                if (overlay) {
                    overlay.classList.remove("d-none");
                }

                if (header) {
                    header.classList.add("is-focused");
                }

                if (minicartPopover && minicartPopover.classList.contains("show")) {
                    $("body").trigger("minicart:close");
                }

                let selectElem = document.querySelectorAll("select");
                if (selectElem) {
                    for (var i = 0; i < selectElem.length; i++) {
                        selectElem[i].blur();
                    }
                }

                let $footer = $("footer");
                if ($footer) {
                    let $footerCountrySelector = $footer.find(".country-selector");
                    if ($footerCountrySelector) {
                        $footerCountrySelector.removeClass("show");
                        $footer.find(".c-country-selector__dropdown-menu").removeClass("show");
                        $footer.find(".c-country-selector__btn").attr("aria-expanded", false);
                    }
                }

                if ($(".m-store-locator")) {
                    $(".m-store-locator--search-input").blur();
                }

                if ($(".c-error-message")) {
                    $(".c-error-message").addClass("d-none");
                }

                if ($svgElement) {
                    $svgElement.addClass('shaded');
                }

                // hide overflowing menu items on desktop
                hideOverflowingMenuItems(menuItem);
            });
            menuItem.addEventListener("mouseleave", () => {
                menuItem.querySelector(".js-nav-link").setAttribute("aria-expanded", "false");
                menuItem.querySelector(".l-navigation__dropdown").setAttribute("aria-hidden", "true");
                mainMenu.classList.remove("open-submenu");
                $(".suggestions-wrapper").removeClass("not-visible");
                if (overlay && !mainMenu.classList.contains("in")) {
                    overlay.classList.add("d-none");
                }
                if (header) {
                    header.classList.remove("is-focused");
                }

                if ($svgElement) {
                    $svgElement.removeClass('shaded');
                }

            });
        });
    }
};

/**
    Sticky header event. When the user scrolls up and down the header is sticky.
    */

const stickyHeader = (navBar) => {
    let navBarHeight = navBar.offsetHeight;
    let sticky = (navBar.offsetTop + navBarHeight) / 2;

    if (window.pageYOffset >= sticky) {
        if (scrolled || navBar.classList.contains("fixed-top")) {
            return;
        }
        navBar.classList.add("fixed-top");
        mainContent.style.marginTop = navBarHeight + "px";
        scrolled = true;
    } else {
        navBar.classList.remove("fixed-top");
        mainContent.style.marginTop = 0;
        scrolled = false;
    }
};

/**
    When the magnifying glass from the sticky header is clicked the the search box expanded appears.
    */

const displayStickySearch = () => {
    let searchSticky = document.querySelector(".l-header__search-container-expanded");

    magnifyingGlass.addEventListener("click", function () {
        searchSticky.classList.toggle("d-none");

        if (filterBar && filterBar.classList.contains("fixed-top")) {
            filterBar.style.marginTop = document.querySelector(".l-header").offsetHeight + "px";
        }
    });
};

/*
* Hides overflowing level 2 menu items in the desktop dropdown
 * @param {Object} menu - The menu element
 * @returns {void}
*/
const hideOverflowingMenuItems = (menu) =>{
    const $menu = $(menu).find(".js-menu-dropdown-item");

    if (!$menu.length || $menu.length && $menu.hasClass("js-overflow-proceeded")) {
        return;
    }

    const dropdownRect = $menu[0].getBoundingClientRect();

    $menu.addClass("js-overflow-proceeded").find(".column-wrapper").each((index, item) =>{
        let itemRect = item.getBoundingClientRect();

        if ((itemRect.height + itemRect.y) > (dropdownRect.y + dropdownRect.height)) {
            $(item).addClass("d-lg-none");
        }
    });
};

module.exports = function () {
    // Hamburger menu actions
    if ($(".l-navigation").length !== 0) {
        initNavigationMenu();
    }

    $(window).on("orientationchange", debounce(function () {
        if (mainMenu && mainMenu.length !== 0) {
            initNavigationMenu();
        }
    }, 100));

    $(window).on("resize", debounce(function () {
        stickyFilters();
    }, 100));

    initHeaderBanner();

    // Init sticky header
    let navBar = document.querySelector(".l-header");
    if (navBar && !document.querySelector(".m-checkout") && !document.querySelector(".m-cart")) {
        stickyHeader(navBar);
        window.addEventListener("scroll", debounce(function () {
            stickyHeader(navBar);
            stickyFilters();

            if (mainMenu && mainMenu.length !== 0) {
                if (detectTouchDevice.isTouchDevice() && mainMenu.classList.contains("open-submenu")) {
                    overlay.classList.add("d-none");
                }
            }
        }, 100));
    }

    if (magnifyingGlass) {
        displayStickySearch();
    }

    accountPopover.init();

    keyboardAccessibility(
        ".navbar-header .user",
        {
            40: function ($popover) {
                // down
                if (
                    $popover
                        .children("a")
                        .first()
                        .is(":focus")
                ) {
                    $popover
                        .next()
                        .children()
                        .first()
                        .focus();
                } else {
                    $popover
                        .children("a")
                        .first()
                        .focus();
                }
            },
            38: function ($popover) {
                // up
                if (
                    $popover
                        .children("a")
                        .first()
                        .is(":focus")
                ) {
                    $(this).focus();
                    $popover.removeClass("show");
                } else {
                    $popover
                        .children("a")
                        .first()
                        .focus();
                }
            },
            27: function () {
                // escape
                $(".navbar-header .user .popover").removeClass("show");
                $(".user").attr("aria-expanded", "false");
            },
            9: function () {
                // tab
                $(".navbar-header .user .popover").removeClass("show");
                $(".user").attr("aria-expanded", "false");
            }
        },
        function () {
            var $popover = $(".user .popover li.nav-item");
            return $popover;
        }
    );

    $(".navbar-header .user").on("mouseenter focusin", function () {
        var $navbarPopover = $(".navbar-header .user .popover");

        if ($navbarPopover.length > 0) {
            $navbarPopover.addClass("show");
            $(".user").attr("aria-expanded", "true");
        }
    });

    $(".navbar-header .user").on("mouseleave", function () {
        $(".navbar-header .user .popover").removeClass("show");
        $(".user").attr("aria-expanded", "false");
    });
};
